module.exports = __webpack_public_path__ + "img/Cool TAQBIN.f3e289f8.png";